export default {
  key: 'folderColoursEnabled',
  description: "Always on or Always off sets it for everyone in your team, and members can't change it in My profile.",
  featureFlag: 'MARK-25-folder-colours',
}
